import { render, staticRenderFns } from "./trainingWizardView.vue?vue&type=template&id=56f40eba&scoped=true"
import script from "./trainingWizardView.vue?vue&type=script&lang=js"
export * from "./trainingWizardView.vue?vue&type=script&lang=js"
import style0 from "./trainingWizardView.vue?vue&type=style&index=0&id=56f40eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f40eba",
  null
  
)

export default component.exports